import {
  MbMyaccountAddressbookConnector
} from '../../../connectors/mb-myaccount-addressbook.connector'
import { map, shareReplay } from 'rxjs/operators'
import { MbCheckoutRegions } from '../../../../models'

export abstract class MbMyaccountAddressbookBaseComponent {

  checkoutRegion: MbCheckoutRegions | undefined
  addresses$ = this.mbMyaccountAddressbookConnector.getAllAddresses().pipe(
    shareReplay(1)
  )
  billingAddresses$ = this.addresses$.pipe(
    map(addresses => addresses.filter(address => address.billingAddress))
  )
  shippingAddresses$ = this.addresses$.pipe(
    map(addresses => addresses.filter(address => address.shippingAddress))
  )

  constructor (protected mbMyaccountAddressbookConnector: MbMyaccountAddressbookConnector) {
  }
}
